<template lang="pug">
 .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5
          v-row(no-gutters)
            v-col
              p.mb-0.title Edit Appointment
            v-col.shrink
              v-btn.mr-n2(text icon @click="showModal = !showModal" height)
                v-icon(size="24") mdi-close
        v-divider
        v-card-text.pa-0
          v-form(ref="form")
            v-card.pa-4.text-center
              p.font-weight-bold.mb-1 Set Start Time
              div.px-4.text-center
                v-time-picker.elevation-2.mb-4(v-model="editSession.start_time" :landscape="$vuetify.breakpoint.mdAndUp" :max="editSession.end_time" full-width)
              p.font-weight-bold.mt-3.mb-1 Set End Time
              div.px-4.text-center
                v-time-picker.elevation-2.mb-4(v-model="editSession.end_time" :landscape="$vuetify.breakpoint.mdAndUp" :min="editSession.start_time" full-width)
              v-layout.mt-8.d-flex.justify-center
                p.font-weight-bold.my-auto.mr-3 Slot Quantity
                v-btn.my-auto(icon @click="editSession.slots--" :disabled="editSession.slots <= 1")
                  v-icon(size="25" color="teal") mdi-minus-circle
                div.colbox.my-auto(style="width: 70px")
                  span.subtitle-1 {{ editSession.slots }}
                v-btn.my-auto(icon  @click="editSession.slots++")
                  v-icon(size="25" color="teal") mdi-plus-circle
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='grey', text @click='showModal = false')
            | Cancel
          v-btn.mr-2(color='accent' depressed height=32 @click="clickSave" :loading="isLoading")
            div save
</template>

<script>
export default {
  name: 'EditSession',
  props: ['open', 'session'],
  data: () => ({
    isLoading: false,
    editSession: {}
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.editSession = {...this.session}
  },
  methods: {
    clickSave () {
      this.$emit('update:session', {})
      this.$emit('updateSession', this.editSession)
      this.showModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 2px solid #009688;
  border-radius: 5px;
  height: 35px
}
</style>